import formatMoney from '../../core/formatMoney';
import { handleize } from '../../core/helpers';
import variantImages from './variant-images';

// Look at snippets/product-details.liquid as reference
const getFitsOptions = () => {
  return `
    <div class="product-option" data-quickview-option-fit>
      <div class="product-option__head">
        <p class="product-option__title">Fit</p>
      </div>

      <div class="product-option__fits" data-quickview-product-option-fits>
        <ul role="list">
          <li role="listitem">
            <button 
              class="product-option__fit btn btn--secondary" 
              data-quickview-product-option-fit 
              data-fit-value="Standard" 
              data-fit-handle="standard"
              type="button"
              aria-label="Standard">
              <span>Standard</span>
            </button>
          </li>
          <li role="listitem">
            <button 
              class="product-option__fit btn btn--secondary" 
              data-quickview-product-option-fit 
              data-fit-value="Plus" 
              data-fit-handle="plus"
              type="button"
              aria-label="Plus">
              <span>Plus</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  `;
};

// Look at snippets/product-details.liquid as reference
const getColorOptions = (all_variants, variants_data, swatches_data) => {
  try {
    console.log('swatches_data', swatches_data);

    let html = `
      <div class="product-option" data-quickview-option-color data-option-index="0">
        <p class="product-option__title">Color: <span data-selected-color></span></p>
        <div class="product-option__colors" data-quickview-product-option-colors tabindex="0">
    `;

    // Extract the unique colors from the product variants
    const colors = Array.from(new Set(all_variants.map(variant => variant.selectedOptions[0].value)));

    for (let i = 0; i < colors.length; i++) {
      const color = colors[i];
      const color_handle = handleize(color);

      // Make sure at least 1 size is available to show the swatch option
      let total_inventory = 0;
      all_variants.forEach(variant => {
        if (variant.selectedOptions[0].value === color) {
          total_inventory += (variant.astrOnlineInventory === null) ? Number(variant.quantityAvailable) : Number(variant.astrOnlineInventory.value);
        }
      });

      const is_plus_color = (color_handle.includes('plus-size'));
      console.log('Color: ', color, 'Is Plus: ', is_plus_color);

      if (total_inventory <= 0) {
        continue;
      }

      let swatch_span = '<span style="background-color: #FFFFFF;"></span>';
      if (swatches_data.length > 0) {
        swatches_data.find(swatch => {
          if (swatch.color_handle === color_handle) {
            swatch_span = (swatch.swatch_value.length <= 7 && swatch.swatch_value.includes('#') && swatch.swatch_type === 'hex') ? `<span style="background-color:${swatch.swatch_value};"></span>` :
              (swatch.swatch_value === null) ? `<span><img src="https://cdn.shopify.com/s/files/1/2483/6632/files/pixel-transparent_68x68.png?v=1687290419" alt="${color} color swatch" height="34" width="34"></span>` : `<span><img src="${swatch.swatch_value}" alt="${color} color swatch" height="34" width="34"></span>`;
          }
        });
      }

      html += `
        <div class="product-option__color color-swatch" data-variant-id="${variants_data[0].id.split('/').pop()}" data-quickview-product-option-color data-color-value="${color}" data-color-handle="${color_handle}" tabindex="0" role="button" aria-label="Color ${color}"${(window.Shopify.shop.includes('staging') ? ' data-staging-swatch' : '')} data-plus-color="${is_plus_color}">${swatch_span}</div>
      `;
    }

    html += `
    </div>
    `;

    return html;
  } catch (error) {
    console.log('[Quickview] Colors options error', error);
    return '';
  }
};

// Look at snippets/product-details.liquid as reference
const getSizesOptions = (all_variants) => {
  try {
    let html = `
        <div class="product-option__head">
          <p class="product-option__title">Size: <span data-selected-size="">Please select a size</span></p>
        </div>

        <div class="product-option__sizes" data-quickview-product-option-sizes>
          <div class="product-option__sizes-wrapper">
            <ul role="list" aria-label="Select a size">
    `;

    // Extract the unique sizes from the product variants
    const sizes = Array.from(new Set(all_variants.map(variant => variant.selectedOptions[1].value)));

    // console.log('sizes', sizes);

    sizes.forEach(size => {
      const size_handle = handleize(size);

      // html += `
      //   <div class="product-option__size disabled" data-quickview-product-option-size data-size-value="${size}" data-size-handle="${size_handle}" tabindex="0" role="button" aria-label="Size ${size}"><span>${size.toUpperCase()}</span></div>
      // `;

      html += `
      <li role="listitem">
        <button 
          type="button"
          class="product-option__size" 
          data-quickview-product-option-size
          data-size-value="${size}" 
          data-size-handle="${size_handle}" 
          aria-label="Size ${size}">
            <span>${size.toUpperCase()}</span>
        </button>
      </li>
      `;
    });

    html += `
          </ul>
        </div>

        <button type="button" class="product-option__sizes-fit no-themed" data-quickview-sizes-fit>view <span>plus</span> sizes</button>
      </div>

      <div class="product-option__sizes-error" data-product-option-sizes-error role="alert" aria-live="polite"></div>
    `;

    return html;
  } catch (error) {
    console.log('[Quickview] Sizes options error', error);
    return '';
  }
};

const getSizesOptionsList = (all_variants) => {
  try {
    let html = `
      <select name="id" class="no-js" data-quickview-product-select aria-label="Product">
    `;

    all_variants.forEach(variant => {
      const online_inventory = (variant.astrOnlineInventory === null) ? variant.quantityAvailable : Number(variant.astrOnlineInventory.value);
      const variant_id = variant.id.split('/').pop();

      const available = (online_inventory > 0) ? '' : ` disabled="disabled"`;
      html += `<option${available} value="${variant_id}" data-inventory-quantity="${online_inventory}"></option>`;
    });

    html += `
      </select>
    `;

    return html;
  } catch (error) {
    console.log('[Quickview] Sizes options list error', error);
    return '';
  }
};

const getSameColorVariants = (selected_color) => {
  const trimmed_selected_color = selected_color?.trim() || '';
  try {
    if (window.theme.quickview.product === null) {
      throw new Error('Missing product data');
    }

    // Extract the same color variants
    const same_color_variants_edges = window.theme.quickview.product.variants.edges.filter(variant => {
      const has_color = variant.node.selectedOptions.find(opt => opt.name === 'Color' && opt.value.trim() === trimmed_selected_color);
      return typeof has_color !== 'undefined';
    });

    if (same_color_variants_edges.length === 0) {
      throw new Error(`No variants with same color "${selected_color}" found`);
    }

    return same_color_variants_edges;
  } catch (error) {
    console.log('[Quickview] Same color variants error', error);
    return null;
  }
};

// variants_nodes is an array of cleaned up variants done in initProductOptions
const getSameColorSizeVariant = (variants_nodes, selected_color, selected_size) => {
  try {
    if (window.theme.quickview.product === null) {
      throw new Error('Missing product data');
    }

    const trimmed_selected_color = selected_color?.trim() || '';
    const trimmed_selected_size = selected_size?.trim() || '';

    const variant_edge = variants_nodes.filter(variant => {
      if (variant.selectedOptions.length < 2) {
        return false;
      }
      return (
        variant.selectedOptions[0].value.trim() === trimmed_selected_color &&
        variant.selectedOptions[1].value.trim() === trimmed_selected_size
      );
    });

    if (variant_edge.length === 0) {
      throw new Error('No variants with same color and size found');
    }

    return variant_edge[0];
  } catch (error) {
    console.log('[Quickview] Same color and size variant error', error);
    return null;
  }
};

// Main product price
// color_variants: Storefront API variant nodes of the selected color
// selected_variant: variant node of the selected size if any, otherwise "From" the lowest price when the sizes don't share the same price
const getProductPrice = (color_variants, selected_variant = null) => {
  try {
    const prices = color_variants.map(variant => Number(variant.price.amount));
    const min_price = Math.min(...prices);

    if (selected_variant === null && min_price < Math.max(...prices)) {
      return `
        <div data-price-wrapper>
          <span class="product-price--from" data-product-price><span class="price-from">From </span>${formatMoney(min_price * 100, theme.moneyFormat)}</span>
        </div>
      `;
    }

    const current_variant = selected_variant || color_variants[0];
    const isSale = current_variant.compareAtPrice !== null && Number(current_variant.compareAtPrice.amount) > Number(current_variant.price.amount);
    let $html = `
      <div data-price-wrapper${isSale ? ' class="product-price--sale"' : ''}>`;
    $html += `<span data-product-price>${formatMoney(Number(current_variant.price.amount) * 100, theme.moneyFormat)}</span>`;

    if (isSale) {
      $html += `
            <span class="visually-hidden" data-compare-text="">Regular price</span>
            <s data-compare-price>${formatMoney(Number(current_variant.compareAtPrice.amount) * 100, theme.moneyFormat)}</s>
          `;
    }

    $html += `
      </div>
    `;

    return $html;
  } catch (error) {
    console.log('[Quickview] Product price error', error);
    return '';
  }
};

// Refresh the price after selecting a color or a size
const updateProductPrice = (variants, selected_color, selected_variant_id = '') => {
  const color_variants = variants.map(edge => edge.node).filter(variant =>
    variant.selectedOptions.some(opt => opt.name === 'Color' && opt.value === selected_color)
  );
  if (!color_variants.length) {
    return;
  }

  const selected_variant = color_variants.find(variant => variant.id.split('/').pop() === String(selected_variant_id)) || null;
  const price_html = getProductPrice(color_variants, selected_variant);

  document.querySelectorAll('#quicklook-modal [data-price-wrapper], #quicklook-modal-mobile [data-price-wrapper]').forEach((price_wrapper) => {
    price_wrapper.outerHTML = price_html;
  });
};

const updateAddToCartStatus = (selected_variant, preselected_size) => {
  const buyNowBtn = document.querySelector('[data-quickview-buy-now]');
  const availableEl = document.querySelector('[data-quickview-add-to-cart-available]');
  const unavailableEl = document.querySelector('[data-quickview-add-to-cart-unavailable]');
  const addToBagBtn = document.querySelector('[data-quickview-add-to-cart]');

  if (selected_variant.available) {
    if (buyNowBtn) buyNowBtn.disabled = false;
    if (availableEl) availableEl.classList.remove('visually-hidden');
    if (unavailableEl) unavailableEl.classList.add('visually-hidden');
  } else {
    if (buyNowBtn) buyNowBtn.disabled = true;
    if (availableEl) availableEl.classList.add('visually-hidden');
    if (unavailableEl) unavailableEl.classList.remove('visually-hidden');
  }

  if (preselected_size === '') {
    if (buyNowBtn) buyNowBtn.disabled = true;
    if (addToBagBtn) addToBagBtn.classList.add('need-size');
  }
};

const initExtraContent = (product, selectedColor) => {
  try {
    console.log('[Quickview] Sizes extra', selectedColor, product);

    /*
    astrSizefitHeight: {value: `5'9"`}
    strSizefitSize: {value: 'XS'}
    astrSizefitSizingRecommendation: null
    */

    const productDescriptionEl = document.querySelectorAll('[data-quickview-extra-description]');
    const sizeFitHeightEl = document.querySelectorAll('[data-quickview-extra-sizefit-height]');
    const sizeFitSizeEl = document.querySelectorAll('[data-quickview-extra-sizefit-size]');
    const sizeFitSizingRecommendationEl = document.querySelectorAll('[data-quickview-extra-sizefit-sizing_recommendation]');
    const imageModelInfoEl = document.querySelectorAll('[data-quicklook-modal] .product-main-info__item--model, [data-quickview-mobile] .product-main-info__item--model');

    if (productDescriptionEl.length) {
      productDescriptionEl.forEach(el => {
        el.classList.add('visually-hidden');
        el.parentElement.classList.add('visually-hidden');
        el.textContent = '';
      });
    }
    if (sizeFitHeightEl.length) {
      sizeFitHeightEl.forEach(el => {
        el.parentElement.classList.add('visually-hidden');
        el.textContent = '';
      });
    }
    if (sizeFitSizeEl.length) {
      sizeFitSizeEl.forEach(el => {
        el.parentElement.classList.add('visually-hidden');
        el.textContent = '';
      });
    }
    if (sizeFitSizingRecommendationEl.length) {
      sizeFitSizingRecommendationEl.forEach(el => {
        el.parentElement.classList.add('visually-hidden');
        el.textContent = '';
      });
    }
    if (imageModelInfoEl.length) {
      imageModelInfoEl.forEach(el => {
        el.classList.add('visually-hidden');
      });
    }

    let productDescription = product.description || null;
    let sizeFitHeight = product.astrSizefitHeight?.value || null;
    let sizeFitSize = product.astrSizefitSize?.value || null;
    let sizeFitSizingRecommendation = product.astrSizefitSizingRecommendation?.value || null;

    const sameColorVariants = getSameColorVariants(selectedColor);
    const hasProductDescription = sameColorVariants.some(variant => !!variant?.node?.astrStyleDescription);
    const hasSizefitHeight = sameColorVariants.some(variant => !!variant?.node?.astrStyleSizefitHeight);
    const hasSizefitSize = sameColorVariants.some(variant => !!variant?.node?.astrStyleSizefitSize);
    const hasSizefitSizingRecommendation = sameColorVariants.some(variant => !!variant?.node?.astrStyleSizefitSizingRecommendation);

    if (hasProductDescription) {
      productDescription = sameColorVariants.find(variant => !!variant?.node?.astrStyleDescription)?.node?.astrStyleDescription?.value;
    }
    if (hasSizefitHeight) {
      sizeFitHeight = sameColorVariants.find(variant => !!variant?.node?.astrStyleSizefitHeight)?.node?.astrStyleSizefitHeight?.value;
    }
    if (hasSizefitSize) {
      sizeFitSize = sameColorVariants.find(variant => !!variant?.node?.astrStyleSizefitSize)?.node?.astrStyleSizefitSize?.value;
    }
    if (hasSizefitSizingRecommendation) {
      sizeFitSizingRecommendation = sameColorVariants.find(variant => !!variant?.node?.astrStyleSizefitSizingRecommendation)?.node?.astrStyleSizefitSizingRecommendation?.value;
    }

    if (productDescriptionEl.length && productDescription && typeof productDescription !== 'undefined') {
      productDescriptionEl.forEach(el => {
        el.innerHTML = productDescription;
        el.classList.remove('visually-hidden');
        el.parentElement.classList.remove('visually-hidden');
      });
    }
    if (sizeFitHeightEl.length && sizeFitHeight && typeof sizeFitHeight !== 'undefined') {
      sizeFitHeightEl.forEach(el => {
        el.textContent = sizeFitHeight;
        el.parentElement.classList.remove('visually-hidden');
      });
    }
    if (sizeFitSizeEl.length && sizeFitSize && typeof sizeFitSize !== 'undefined') {
      sizeFitSizeEl.forEach(el => {
        el.textContent = sizeFitSize;
        el.parentElement.classList.remove('visually-hidden');
      });
    }
    if (imageModelInfoEl.length && sizeFitHeight && sizeFitSize && typeof sizeFitHeight !== 'undefined' && typeof sizeFitSize !== 'undefined') {
      imageModelInfoEl.forEach(el => {
        el.classList.remove('visually-hidden');
      });
    }
    if (sizeFitSizingRecommendationEl.length && sizeFitSizingRecommendation && typeof sizeFitSizingRecommendation !== 'undefined') {
      sizeFitSizingRecommendationEl.forEach(el => {
        el.textContent = sizeFitSizingRecommendation;
        el.parentElement.classList.remove('visually-hidden');
      });
    }
  } catch (error) {
    console.log('[Quickview] Sizes extra error', error);
    return;
  }
};

// Init the product options after rendering the initial code
const initProductOptions = (variants, preselected_color = '', preselected_size = '') => {
  try {
    console.log('[Quickview] init variants', variants, ' // preselected_color: "', preselected_color, '" // preselected_size: "', preselected_size, '"');

    if (!variants.length) {
      return;
    }

    const variants_nodes = variants.map(variant => {
      const variant_node = variant.node;
      const online_inventory = (variant_node.astrOnlineInventory === null) ? variant_node.quantityAvailable : Number(variant_node.astrOnlineInventory.value);

      return {
        astrOnlineInventory: online_inventory,
        available: online_inventory > 0,
        compareAtPrice: (variant_node.compareAtPrice === null) ? '' : variant_node.compareAtPrice.amount,
        id: variant_node.id.split('/').pop(),
        image_url: (variant_node.image === null) ? '' : variant_node.image.url,
        image_alt: (variant_node.image === null) ? '' : variant_node.image.altText,
        price: (variant_node.price === null) ? '' : variant_node.price.amount,
        selectedOptions: variant_node.selectedOptions,
        title: variant_node.title,
      };
    });

    console.log('[Quickview] variants', variants_nodes);

    const selected_color = (preselected_color === '') ? variants_nodes[0].selectedOptions[0].value : preselected_color;
    const selected_color_handle = handleize(selected_color);

    const selected_color_variants = variants_nodes.filter(variant =>
      variant.selectedOptions.some(opt => opt.name === 'Color' && opt.value === selected_color)
    );
    console.log('[Quickview] selected_color_variants', selected_color_variants);
    if (!selected_color_variants.length) {
      console.log('[Quickview] No variants found for the selected color', selected_color);
      return;
    }

    // Before the availability checks so a sold out color still shows its own price
    const price_size_variant = (preselected_size !== '') ? getSameColorSizeVariant(variants_nodes, selected_color, preselected_size) : null;
    updateProductPrice(variants, selected_color, price_size_variant?.id);

    // Find the 1st available size when opening the modal or selected size after selecting a size option
    const selected_color_available_variants = selected_color_variants.filter(variant => variant.available);
    console.log('[Quickview] selected_color_available_variants', selected_color_available_variants);
    if (!selected_color_available_variants.length) {
      console.log('[Quickview] No available variants for the selected color');
      return;
    }

    const mobileColorLabel = document.querySelector('#quicklook-modal-mobile [data-selected-color-label] span');
    if (mobileColorLabel) {
      mobileColorLabel.innerHTML = selected_color.replace('Plus Size - ', '');
    }
    const desktopColorLabel = document.querySelector('#quicklook-modal [data-selected-color-label] span');
    if (desktopColorLabel) {
      desktopColorLabel.innerHTML = selected_color.replace('Plus Size - ', '');
    }

    // Update the selected color name in the color option title
    const qv_container_id = (window.theme.breakpoints.current === 'mobile') ? 'quicklook-modal-mobile' : 'quicklook-modal';
    const qv_container = document.getElementById(qv_container_id);
    if (qv_container) {
      const selectedColorSpan = qv_container.querySelector('[data-quickview-option-color] [data-selected-color]');
      if (selectedColorSpan) {
        selectedColorSpan.textContent = selected_color;
      }
    }

    let selected_size_variant = null;
    if (preselected_size !== '') {
      selected_size_variant = getSameColorSizeVariant(variants_nodes, preselected_color, preselected_size);
    }
    // console.log('selected_size_variant', selected_size_variant);

    const default_variant = (preselected_size === '') ? selected_color_available_variants[0] : selected_size_variant;
    if (default_variant === null) {
      console.log('[Quickview] No available variants for the selected color and size');
      return;
    }

    console.log('[Quickview] Selected variant', default_variant);

    const qvMobile = document.getElementById('quicklook-modal-mobile');
    const qvDesktop = document.getElementById('quicklook-modal');
    const qvElement = (qvMobile && qvMobile.classList.contains('active')) ? qvMobile : qvDesktop;

    if (!qvElement) return;

    // Handle the disabled state on size options
    qvElement.querySelectorAll('[data-quickview-product-option-size]').forEach(sizeBtn => {
      sizeBtn.classList.add('disabled');
      sizeBtn.setAttribute('aria-disabled', true);
      sizeBtn.setAttribute('aria-label', `Size is ${window.theme.strings.soldOut}`);
    });

    selected_color_available_variants.forEach(variant => {
      const sizeValue = variant.selectedOptions[1].value;
      const sizeBtn = qvElement.querySelector(`[data-quickview-product-option-size][data-size-value="${sizeValue}"]`);
      if (sizeBtn) {
        sizeBtn.classList.remove('disabled');
        sizeBtn.setAttribute('aria-disabled', false);
        sizeBtn.setAttribute('aria-label', `Size ${sizeValue}`);
      }
    });

    const selected_size = default_variant.selectedOptions[1].value;
    const selected_size_handle = handleize(selected_size);

    console.log('[Quickview] Default variant', default_variant);

    qvElement.querySelectorAll('[data-quickview-product-option-color]').forEach(el => el.classList.remove('active'));
    qvElement.querySelectorAll('[data-quickview-product-option-size]').forEach(el => el.classList.remove('active'));

    const colorBtn = qvElement.querySelector(`[data-quickview-product-option-color][data-color-handle="${selected_color_handle}"]`);
    if (colorBtn) colorBtn.classList.add('active');

    // Per request, we're not pre-selecting the 1st size available
    if (preselected_size !== '') {
      const sizeBtn = qvElement.querySelector(`[data-quickview-product-option-size][data-size-handle="${selected_size_handle}"]`);
      if (sizeBtn) sizeBtn.classList.add('active');
      const productSelect = qvElement.querySelector('[data-quickview-product-select]');
      if (productSelect) {
        productSelect.value = default_variant.id;
        productSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateAddToCartStatus(default_variant, preselected_size);

    // Update the product-extra content
    // dynamicProductExtra(selected_color, true);
    initExtraContent(window.theme.quickview.product, selected_color);

    // Update the "see full details" link & product title link
    const view_details_elements = qvElement.querySelectorAll(`[data-quickview-view-details]`);
    const view_details_link_elements = qvElement.querySelectorAll(`[data-quickview-view-details] a`);
    const desktop_title_elements = qvElement.querySelectorAll(`[data-product-scrollable-details] .product-details__title`);

    if (view_details_elements.length > 0) {
      const view_details_base_link = view_details_elements[0].dataset.quickviewViewDetailsBaseLink;
      const color_link = `${view_details_base_link}?color=${selected_color}&variant=${default_variant.id}`;

      view_details_link_elements.forEach(el => el.href = color_link);
      desktop_title_elements.forEach(title => { title.href = color_link; });
    }

    // If we have both standard and plus sizes, show the fit option, select the correct fit option and hide opposite colors
    const has_standard_size = variants.some((variant) => {
      const variant_node = variant.node;
      return variant_node.availableForSale && !variant_node.title.includes('Plus Size -');
    });
    const has_plus_size = variants.some((variant) => {
      const variant_node = variant.node;
      return variant_node.availableForSale && variant_node.title.includes('Plus Size -');
    });
    if (has_standard_size && has_plus_size) {
      const fitRow = qvElement.querySelectorAll('[data-quickview-option-fit]');
      if (fitRow) fitRow.forEach(el => el.classList.add('active'));

      // Select the correct fit option
      const fit_option = selected_color.includes('Plus Size -') ? 'plus' : 'standard';
      const fit_option_btns = qvElement.querySelectorAll('[data-quickview-product-option-fit]');

      if (fit_option_btns) fit_option_btns.forEach(btn => btn.classList.remove('active'));
      const fit_option_btn = qvElement.querySelectorAll(`[data-quickview-product-option-fit][data-fit-handle="${fit_option}"]`);
      if (fit_option_btn) fit_option_btn.forEach(el => el.classList.add('active'));
      // Hide opposite colors
      qvElement.querySelectorAll('[data-quickview-product-option-color]').forEach(el => {
        el.classList.add('hidden');

        if (fit_option === 'plus' && el.dataset.plusColor === 'true') {
          el.classList.remove('hidden');
        } else if (fit_option === 'standard' && el.dataset.plusColor === 'false') {
          el.classList.remove('hidden');
        }
      });

      // Update the toggle sizes link
      const sizesFitBtn = qvElement.querySelectorAll('[data-quickview-sizes-fit]');
      if (sizesFitBtn) {
        const toggleFit = fit_option === 'plus' ? 'standard' : 'plus';
        sizesFitBtn.forEach(el => {
          el.classList.remove('visually-hidden');
          el.querySelector('span').textContent = toggleFit;
          el.dataset.targetFit = toggleFit;
        });
      }
    } else {
      const sizesFitBtn = qvElement.querySelectorAll('[data-quickview-sizes-fit]');
      if (sizesFitBtn) sizesFitBtn.forEach(el => el.classList.add('visually-hidden'));
    }

    // Wishlist
    // const isVisible = qvElement ? window.getComputedStyle(qvElement).display !== 'none' : false;
    // const event_name = isVisible ? 'quickview:variant-change' : 'quickview-mobile:variant-change';
    // const quickview_change = new CustomEvent(event_name, { bubbles: true, detail: { variant: default_variant } });
    // document.dispatchEvent(quickview_change);
  } catch (error) {
    console.log('[Quickview] Product options initialization error', error);
    return null;
  }
};

const selectColorQuicklook = (item) => {
  try {
    if (item.classList.contains('active')) {
      return;
    }

    if (window.theme.quickview.product === null) {
      throw new Error('Missing product data');
    }

    const isMobileModal = item.closest('.quickview-modal-mobile') !== null;
    const qv_container_id = isMobileModal ? 'quicklook-modal-mobile' : 'quicklook-modal';
    const qv_container = document.getElementById(qv_container_id);
    if (!qv_container) return;

    const edit_mode = document.body.classList.contains('edit-cart');

    qv_container.querySelectorAll('[data-quickview-product-option-color]').forEach(el => el.classList.remove('active'));
    item.classList.add('active');

    const selected_color_name = item.dataset.colorValue;
    const same_color_variants_edges = getSameColorVariants(selected_color_name);
    const same_color_variants = same_color_variants_edges.map(edge => edge.node);

    // Close and clear any open zoom overlay before swapping images
    const activeZoomOverlay = qv_container.querySelector('.product-zoom-overlay.active');
    if (activeZoomOverlay) {
      activeZoomOverlay.classList.remove('active');
      const zoomImg = activeZoomOverlay.querySelector('img');
      if (zoomImg) zoomImg.src = '';
      qv_container.querySelector('[data-product-scrollable-images]')?.style.removeProperty('overflow');
    }
    // Always restore image grid opacity on color change
    const imageGrid = qv_container.querySelector('[data-product-scrollable-images] [data-product-full]');
    if (imageGrid) imageGrid.style.opacity = '1';

    const max_images = (edit_mode) ? 1 : 6;

    // Replace the images
    if (!isMobileModal) {
      const images_html = variantImages(same_color_variants[0], max_images);
      const scrollableImages = qv_container.querySelector('[data-product-scrollable-images] [data-product-full]');
      if (images_html !== '' && scrollableImages) {
        // Lock height to prevent layout jump — hold until first image loads
        const mediaContainer = qv_container.querySelector('[data-product-scrollable-images]');
        if (mediaContainer) mediaContainer.style.minHeight = `${mediaContainer.offsetHeight}px`;
        if (scrollableImages) scrollableImages.style.minHeight = `${scrollableImages.offsetHeight}px`;

        scrollableImages.innerHTML = images_html;
        scrollableImages.scrollLeft = 0;

        const releaseHeightLock = () => {
          if (mediaContainer) mediaContainer.style.minHeight = '';
          if (scrollableImages) scrollableImages.style.minHeight = '';
        };
        const firstNewImage = scrollableImages.querySelector('img');
        if (firstNewImage) {
          firstNewImage.addEventListener('load', releaseHeightLock, { once: true });
          firstNewImage.addEventListener('error', releaseHeightLock, { once: true });
          setTimeout(releaseHeightLock, 1000); // Fallback
        } else {
          releaseHeightLock();
        }
      }
    } else {
      const images_html = variantImages(same_color_variants[0], 6);
      const mobileImagesContainer = qv_container.querySelector('[data-quickview-mobile-images] [data-product-full]');
      if (images_html !== '' && mobileImagesContainer) {
        const mobileMediaContainer = qv_container.querySelector('[data-quickview-mobile-images]');
        if (mobileMediaContainer) mobileMediaContainer.style.minHeight = `${mobileMediaContainer.offsetHeight}px`;
        if (mobileImagesContainer) mobileImagesContainer.style.minHeight = `${mobileImagesContainer.offsetHeight}px`;

        mobileImagesContainer.innerHTML = images_html;
        mobileImagesContainer.scrollLeft = 0;

        const releaseMobileHeightLock = () => {
          if (mobileMediaContainer) mobileMediaContainer.style.minHeight = '';
          if (mobileImagesContainer) mobileImagesContainer.style.minHeight = '';
        };
        const firstMobileImage = mobileImagesContainer.querySelector('img');
        if (firstMobileImage) {
          firstMobileImage.addEventListener('load', releaseMobileHeightLock, { once: true });
          firstMobileImage.addEventListener('error', releaseMobileHeightLock, { once: true });
          setTimeout(releaseMobileHeightLock, 1000); // Fallback
        } else {
          releaseMobileHeightLock();
        }
      }
    }

    // Reinit the price - All sizes have the same price (all colors as well, but better to be careful since colors are styles)
    // const price_html = getProductPrice(same_color_variants[0]);
    // const priceWrapper = qv_container.querySelector('[data-price-wrapper]');
    // if (priceWrapper) priceWrapper.remove();
    // const productPricing = qv_container.querySelector('[data-product-pricing]');
    // if (productPricing) productPricing.insertAdjacentHTML('beforeend', price_html);

    // Reinit the sizes
    const sizes_html = getSizesOptions(same_color_variants);
    const sizeOptionContainer = qv_container.querySelector('[data-quickview-option-size]');
    if (sizeOptionContainer) {
      sizeOptionContainer.innerHTML = sizes_html;
    }

    // Reinit options and ctas
    initProductOptions(window.theme.quickview.product.variants.edges, selected_color_name);

    // Disable the update button if it's an edit from the cart
    const updateBtn = document.querySelector('[data-quickview-update]');
    if (updateBtn) updateBtn.disabled = true;

    // Update the selected color name
    const colorSpan = qv_container.querySelector('[data-quickview-option-color] [data-selected-color]');
    if (colorSpan) colorSpan.textContent = selected_color_name.replace('Plus Size - ', '');

    // Update the product-extra content
    // dynamicProductExtra(selected_color_name, true);
    initExtraContent(window.theme.quickview.product, selected_color_name);
  } catch (error) {
    console.log('[Quickview] Product color selection error', error);
    return;
  }
};

const selectFitQuicklook = (item) => {
  try {
    if (item.classList.contains('active')) {
      return;
    }

    const isMobileModal = item.closest('.quickview-modal-mobile') !== null;
    const qvElementID = isMobileModal ? 'quicklook-modal-mobile' : 'quicklook-modal';
    const qvElement = document.getElementById(qvElementID);
    const edit_mode = document.body.classList.contains('edit-cart');
    if (!qvElement || edit_mode) return;

    // Get the active color
    const active_color = qvElement.querySelector('[data-quickview-product-option-color].active');

    qvElement.querySelectorAll('[data-quickview-product-option-fit]').forEach(el => el.classList.remove('active'));
    item.classList.add('active');

    // Show the correct colors
    const fit_handle = item.dataset.fitHandle;
    qvElement.querySelectorAll('[data-quickview-product-option-color]').forEach(el => {
      el.classList.add('hidden');
      el.classList.remove('active');

      if (fit_handle === 'plus' && el.dataset.plusColor === 'true') {
        el.classList.remove('hidden');
      } else if (fit_handle === 'standard' && el.dataset.plusColor === 'false') {
        el.classList.remove('hidden');
      }
    });

    // Activate the correct color - Opposite color if exists else first color available
    let oppositeColorEnabled = false;
    if (active_color) {
      const color_handle = active_color.dataset.colorHandle;
      const fit_option = active_color.dataset.plusColor;
      let opposite_color_btn;
      if (fit_option === 'true') {
        const standard_handle = color_handle.replace('plus-size-', '');
        opposite_color_btn = qvElement.querySelector(`[data-quickview-product-option-color][data-color-handle="${standard_handle}"]`);
      } else {
        opposite_color_btn = qvElement.querySelector(`[data-quickview-product-option-color][data-color-handle="plus-size-${color_handle}"]`);
      }
      if (opposite_color_btn) {
        oppositeColorEnabled = true;
        selectColorQuicklook(opposite_color_btn);
      }
    }

    // Activate the first color available
    if (!oppositeColorEnabled) {
      const color_btn = qvElement.querySelector('[data-quickview-product-option-color]:not(.hidden)');
      if (color_btn) {
        selectColorQuicklook(color_btn);
      }
    }

  } catch (error) {
    console.log('[Quickview] Fit option initialization error', error);
    return null;
  }
};

const selectSizeQuicklook = (item) => {
  try {
    if (item.classList.contains('active') || item.classList.contains('disabled')) {
      return;
    }

    const qv_container_selector = item.closest('.quickview-modal-mobile') === null ? '#quicklook-modal' : '#quicklook-modal-mobile';
    const qv_container = document.querySelector(qv_container_selector);
    if (!qv_container) return;

    qv_container.querySelectorAll('[data-quickview-product-option-size]').forEach(el => el.classList.remove('active'));
    item.classList.add('active');

    const activeColorItem = qv_container.querySelector('[data-quickview-product-option-color].active');
    if (!activeColorItem) {
      console.log('[Quickview] No color selected.');
      return;
    }
    const selected_color_name = activeColorItem.dataset.colorValue;
    const selected_size_name = item.dataset.sizeValue;

    // Remove the size error message if any
    const quicklookModalError = document.querySelector('[data-quicklook-modal] [data-product-option-sizes-error]');
    if (quicklookModalError) {
      quicklookModalError.classList.remove('active');
      quicklookModalError.innerHTML = '';
    }
    const quicklookModalSize = document.querySelector('[data-quicklook-modal] [data-quickview-option-size]');
    if (quicklookModalSize) {
      quicklookModalSize.classList.remove('error');
    }
    const quickviewMobileError = document.querySelector('[data-quickview-mobile] [data-product-option-sizes-error]');
    if (quickviewMobileError) {
      quickviewMobileError.classList.remove('active');
      quickviewMobileError.innerHTML = '';
    }
    const quickviewMobileSize = document.querySelector('[data-quickview-mobile] [data-quickview-option-size]');
    if (quickviewMobileSize) {
      quickviewMobileSize.classList.remove('error');
    }

    // Don't need to refresh the price in this version, all sizes share the same price

    // Reinit options and ctas
    initProductOptions(window.theme.quickview.product.variants.edges, selected_color_name, selected_size_name);

    // Enable the update button if it's an edit from the cart
    const updateBtn = document.querySelector('[data-quickview-update]');
    if (updateBtn) updateBtn.disabled = false;

    // Show "add to bag" instead of "select a size" when a size is selected
    const availableEl = document.querySelector('[data-quickview-add-to-cart-available]');
    if (availableEl) {
      availableEl.textContent = window.theme.strings.addToCart;
      availableEl.setAttribute('aria-label', window.theme.strings.addToCart);
    }
    const addToBagBtn = document.querySelector('[data-quickview-add-to-cart]');
    if (addToBagBtn) addToBagBtn.classList.remove('need-size');

    // Change from "Add to wishlist" to "Remove from wishlist" if the variant is already in the wishlist
    const wishlistBtn = document.querySelector('[data-quickview-add-to-wishlist]');
    if (wishlistBtn) {
      const variantSelectElement = qv_container.querySelector('[data-quickview-product-select]');
      const selectedVariantID = variantSelectElement ? JSON.parse(variantSelectElement.value) : null;

      if (selectedVariantID) {
        const isInWishlist = window.wishlist_products?.some(item => item.epi === selectedVariantID);
        // console.log('[Quickview] Wishlist status for variant', selectedVariantID, isInWishlist);

        if (isInWishlist) {
          wishlistBtn.setAttribute('name', 'remove');
          wishlistBtn.setAttribute('aria-label', window.theme.strings.removeFromWishlist);
          wishlistBtn.setAttribute('title', window.theme.strings.removeFromWishlist);
          wishlistBtn.classList.remove('btn--primary');
          wishlistBtn.classList.add('btn--secondary');
          wishlistBtn.textContent = window.theme.strings.removeFromWishlist;
        } else {
          wishlistBtn.setAttribute('name', 'add');
          wishlistBtn.setAttribute('aria-label', window.theme.strings.addToWishlist);
          wishlistBtn.setAttribute('title', window.theme.strings.addToWishlist);
          wishlistBtn.classList.add('btn--primary');
          wishlistBtn.classList.remove('btn--secondary');
          wishlistBtn.textContent = window.theme.strings.addToWishlist;
        }
        wishlistBtn.removeAttribute('disabled');
      }
    }
  } catch (error) {
    console.log('[Quickview] Product size selection error', error);
    return;
  }
};

export {
  getFitsOptions,
  getColorOptions,
  getSizesOptions,
  getSizesOptionsList,
  getSameColorVariants,
  getProductPrice,
  initProductOptions,
  selectFitQuicklook,
  selectColorQuicklook,
  selectSizeQuicklook,
};
